import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Container, Toast, ToastBody, ToastHeader } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  useDeletePermissionMutation,
  useLazyGetPermissionListQuery,
} from "store/api/permissions/permissions.api"
import TableContainer from "components/Common/TableContainer"
import CreatePermissionModal from "modals/createPermissionModal"
import avatar from "../../assets/images/avatar.png"
import arrowDown from "../../assets/images/icons/arrow-down.svg"
import eye from "../../assets/images/icons/eye.svg"
import edit from "../../assets/images/icons/edit.svg"
import deleteIcon from "../../assets/images/icons/delete-red.svg"
import { Link } from "react-router-dom"
import LoaderComponent from "components/loader"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const REITs = () => {
  const [trigger, { isFetching }] = useLazyGetPermissionListQuery()
  const [open, setOpen] = useState(false)
  const [mutate] = useDeletePermissionMutation()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([
    {
      name: "Rajat Bansal",
      email: "rajat.bansal@prachay.in",
      request: "ICDR1001",
      amount: "₹5,00,000",
      interest: "9.25%",
      status: "Approved",
    },
    {
      name: "Neha Kapoor",
      email: "neha.kapoor@prachay.in",
      request: "ICDR1001",
      amount: "₹5,00,000",
      interest: "9.25%",
      status: "Approved",
    },
    {
      name: "Arvind Chauhan",
      email: "arvind.ch@capitalrise.in",
      request: "ICDR1001",
      amount: "₹5,00,000",
      interest: "9.25%",
      status: "Approved",
    },
    {
      name: "Arvind Chauhan",
      email: "arvind.ch@capitalrise.in",
      request: "ICDR1001",
      amount: "₹5,00,000",
      interest: "9.25%",
      status: "Approved",
    },
  ])
  const [isToast, setIsToast] = useState(false)
  const deleteRef = useRef(null)
  const [editDetails, setEditdetails] = useState(null)
  //meta title
  document.title = "Add REIT"

  const getList = async () => {
    try {
      const { data } = await trigger().unwrap()
      // setData()
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [])

  const onDeletePermission = async () => {
    const data = deleteRef?.current
    if (data) {
      try {
        const res = await mutate(data)
        if (res.data.success) {
          deleteRef.current = null
          getList()
          setIsToast(false)
        }
      } catch (error) {}
    }
  }

  const handleUserClick = () => {
    setOpen(true)
    setEditdetails(null)
  }

  const refreshData = () => {
    getList()
    setOpen(false)
  }

  const columns = useMemo(
    () => [
      {
        header: "REIT Detail",
        accessorKey: "REIT",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            email={row?.original.email}
            name={row?.original.name}
          />
        ),
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            Unit Price (₹) <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "Unit",
        enableColumnFilter: false,
        enableSorting: true,

        cell: ({ row }) => (
          <div className="code-number">{row?.original.request}</div>
        ),
      },

      {
        header: () => (
          <div className="flex items-center gap-2">
            ROI (% p.a.) <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "ROI",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            IMin Investment <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "Investment",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: () => (
          <div className="flex items-center gap-2">
            Status <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-status">
            <div className="badge approved">
              <span></span> {row?.original.status}
            </div>
            {/* <div className="pending">
              <span></span> {row?.original.status}
            </div> */}
            {/* <div className="kyc-pending">
              <span></span> {row?.original.status}
            </div> */}
            {/* <div className="kyc-under-review">
              <span></span> {row?.original.status}
            </div> */}
            {/* <div className="rejected">
              <span></span> {row?.original.status}
            </div> */}
          </div>
        ),
      },
      {
        id: "action",
        header: "",
        cell: ({ row }) => (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div
              className="action-view"
              onClick={() => {
                setEditdetails(row.original)
                setOpen(true)
              }}
            >
              <Link to={"/reits/view"}>
                <img src={eye} alt="" />
              </Link>
            </div>
            <div
              className="action-view"
              onClick={() => {
                setEditdetails(row.original)
                setOpen(true)
              }}
            >
              <Link to={"/reits/view"}>
                <img src={edit} alt="" />
              </Link>
            </div>
            <div
              className="action-view"
              onClick={() => {
                setEditdetails(row.original)
                setOpen(true)
              }}
            >
              <Link to={"/reits/view"}>
                <img src={deleteIcon} alt="" />
              </Link>
            </div>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"REIT Listings"}
            breadcrumbItem={"REIT Listings"}
          />

          <TableContainer
            // isLoading={isFetching}
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            data={data}
            buttonName={"Invite"}
            isGlobalFilter={true}
            isCustomPageSize={true}
            handleUserClick={handleUserClick}
            isPagination={true}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />

          {open && (
            <CreatePermissionModal
              open={open}
              title={!editDetails ? "Create" : "Edit"}
              setOpen={setOpen}
              refreshData={refreshData}
              editData={editDetails}
            />
          )}
        </Container>

        {isToast && (
          <div
            className="position-fixed top-0 start-50 translate-middle-x p-3"
            style={{ zIndex: "1005" }}
          >
            <Toast isOpen={isToast} role="alert">
              <ToastBody>
                Are you sure you want to delete this permission?
                <div className="mt-2 pt-2 border-top">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm me-1"
                    onClick={onDeletePermission}
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => {
                      setIsToast(false)
                      deleteRef.current = null
                    }}
                    type="button"
                    className="btn btn-secondary btn-sm"
                  >
                    No
                  </button>
                </div>
              </ToastBody>
            </Toast>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default REITs
